<template>
  <modal
    title="Edit Tax"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <form class="flex flex-col gap-4">
       
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Tax Authority</label>
        <input type="text" class="input" v-model="newTax.authority" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">Authority Code</label>
        <input type="text" class="input" v-model="newTax.code" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">Tax Label</label>
        <input type="text" class="input" v-model="newTax.label" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">Tax Rate (%)</label>
        <input type="text" class="input" v-model="newTax.rate" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">TIN</label>
        <input type="text" class="input" v-model="newTax.tin" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">Country</label>
        <el-select filterable v-model="newTax.country" placeholder="Select">
          <el-option
            v-for="country in countries"
            :key="country"
            :label="country"
            :value="country"
          >
          </el-option>
        </el-select>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">State</label>
        <el-select filterable v-model="newTax.state" placeholder="Select">
          <el-option
            v-for="state in states"
            :key="state.id"
            :label="state.name"
            :value="state.name"
          >
          </el-option>
        </el-select>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <p class="text-primary-yellow font-semibold">
          Select remittance Option
          <el-tooltip content="Top center" placement="top">
            <!-- <el-button>Dark</el-button> -->
            <span>icon</span>
          </el-tooltip>
        </p>

        <label class="radio-label" for="set-up">
          <input
            type="radio"
            id="set-up"
            :value="true"
            v-model="newTax.isRemittanceEnabled"
          />
          set me up for automatic remittance
          <span></span>
        </label>

        <label class="radio-label" for="no-set-up">
          <input
            type="radio"
            id="no-set-up"
            :value="false"
            v-model="newTax.isRemittanceEnabled"
          />
          Do not set me up for automatic remittance
          <span></span>
        </label>
      </div>
    </form>
    <div class="button-wrapper mt-5">
      <base-button text="Save" :disabled="disableButton" @click="updateTax" />
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Cancel</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["tax", "show-modal"],
  components: {},
  data() {
    return {
      newTax: {
        orgId: localStorage.getItem("organizationId"),
        authority: "",
        label: "",
        rate: "",
        tin: "",
        country: "",
        state: "",
        code: "",
        isRemittanceEnabled: false,
      },
      updatingTax: false,
      states: [],
      showLocationManager: false,
      countries: ["Nigeria"],
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newTax);
    },
  },
  mounted() {
    this.getAllStates();
  },
  methods: {
    updateManager(event) {
      console.log(event, "updt mana");
    },
    async updateTax() {
      this.updatingTax = true;
      try {
        let response = await this.$_updateTax({
            payload:{
                ...this.newTax,
                taxId: this.tax.id
            }
        });
        console.log(response);
        this.updatingTax = false;
        this.generateToast("Tax successfully update!", "success");
        this.$emit("updated");
        this.closeModal();
      } catch (error) {
        this.updatingTax = false;
        this.handleError(error);
      }
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    resetInputFields() {
      this.newTax = {
        authority: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newTax.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newTax.imageurl = null;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
  watch: {
    tax: {
      deep: true,
      immediate: true,
      handler(tax) {
        if (tax.id !== undefined) {
          this.newTax = tax;
         // delete this.newTax.id;
        }
      },
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}
.kpa-summary {
  margin-top: 1rem;
}
.text-grey {
  color: #7a90a7;
}
li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}
</style>
